import React, { useState, } from 'react';
import { useTranslation } from 'react-i18next';
import { createTeam } from '../../api/authenticateAPIs';
import { useNotification } from '../../context/NotificationContext';
import { NotificationType } from '../../enums/NotificationType';
import { useNavigate } from 'react-router-dom';

import UsersMultiselect from '../../components/shared/UsersMultiselect';
import EnvironmentsMultiselect from '../../components/shared/EnvironmentsMultiSelect';

const CreateTeam = () => {

    const { showNotification } = useNotification();
    const navigate = useNavigate();
    const [t] = useTranslation('global');
    const [isLoading, setIsLoading] = useState(false);
    const [formData, setFormData] = useState({name: '', userIds: [], envIds: [], });

    const validateFormData = () => {
        let isValid = true;

        if (!formData.name) {
            showNotification({ message: t('teamNameRequired'), type: NotificationType.Error });
            isValid = false;
        } else if (!formData.userIds.length) {
            showNotification({ message: t('usersRequired'), type: NotificationType.Error });
            isValid = false;
        } 
        // else if (!formData.envIds.length) {
        //     showNotification({ message: t('environmentsRequired'), type: NotificationType.Error });
        //     isValid = false;
        // }

        return isValid;
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    } 

    const handleUserChange = (event) => {
        const {
            target: { value },
        } = event;
        setFormData({
            ...formData,
            userIds: typeof value === 'string' ? value.split(',') : value,
        });
    }; 

    const handleEnvironmentChange = (event) => {
        const {
            target: { value },
        } = event;
        setFormData({
            ...formData,
            envIds: typeof value === 'string' ? value.split(',') : value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        if (validateFormData()) {

            console.log('Submitting: ', formData.name, formData.userIds, formData.envIds);
            try {
                await createTeam(formData.name, formData.userIds, formData.envIds)
                .then(result => {
                    showNotification({ message: t('teamCreated'), type: NotificationType.Success });
                })
                .catch(ex =>{
                    showNotification({ message: ex.message, type: NotificationType.Error });
                })
            } catch (error) {
                console.error("Error creating team: ", error);
            } finally {
                setIsLoading(false);
                handleGoBack();
            }
        } else {
            setIsLoading(false); 
        }
    };

    const handleGoBack = () => {
        navigate('/Teams');
    };

    return (
    <div className='page-wrap'>
        <div className="header-title">
            <h1>{t('newTeam')}</h1>
          </div>

        <form onSubmit={handleSubmit} autoComplete="off" className="input-form">
            <div className='input-section'>
                <div className='input-line'>
                    <label htmlFor='name'>{t('teamName')}</label>
                    <input
                        type="text"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                    />
                </div>
            </div>

            <div className='input-section'>
                <div className='input-line'>
                    <UsersMultiselect
                        selectedValues={formData.userIds}
                        onChange={handleUserChange}
                    />
                </div>
            </div>
           
            <div className='input-section'>
                <div className='input-line'>
                    <EnvironmentsMultiselect
                        selectedValues={formData.envIds}
                        onChange={handleEnvironmentChange}
                    /> 
                </div>
   
            </div>
        </form>

        <button className="return-button" onClick={handleGoBack}>{t('return')}</button>
        <button className="submit-button" type="submit" disabled={isLoading} onClick={handleSubmit}>{t('submit')}</button>
    </div>
    );
}
export default CreateTeam;